import { toast } from "react-toastify";
import { PoliciesColoumn } from "../../../Policy/constants/PolicyColoumn";
import { columnDataFormat, endDates, handleSelectedService, startDates } from "./displayInfinite";
export function isEmptyorInvalidFieldForGrantsAndCharges(index, type) {
    const previousField = type[index];
    return !previousField || !previousField.resourceType
}

export function isEmptyOrInvalidField(index, values) {
    const previousField = values.usageRatePlan[index];
    return (!previousField || !previousField.eventType || !previousField.unitOfMeasurement || !previousField.priority || isEmptyOrInvalidBalanceImpactField(index, values, 0))
}

export function isEmptyOrInvalidBalanceImpactField(index, values, balanceIndex) {
    const field = values.usageRatePlan[index]?.balanceImpacts[balanceIndex];
    return (!field || !field.resourceName || !field.flatRate || !field.pricingModel || !field.validityStart || (field.validityStart.value === 3 && !field.startDateTime) || !field.validityEnd || (field.validityEnd.value === 2 && !field.endDateTime)) || (field.validityEnd.value === 1 && (!field.timeUnit));
}

export function isEmptyOrInvalidBalanceImpactRecurringField(index, values, balanceIndex) {
    const field = values?.recurringUsageRatePlan?.[index]?.balanceImpacts[balanceIndex];
    return (!field || !field.resourceName || !field.flatRate || !field.pricingModel || !field.validityStart || (values?.recurringUsageRatePlan?.[index]?.type == 2 && !field.cycleAlignment) || (values?.recurringUsageRatePlan?.[index]?.type == 2 && !field.recurringFrequency) || (field.validityStart.value === 3 && !field.startDateTime) || (field.validityEnd.value === 1 && (!field.timeUnit)) || !field.validityEnd || (field.validityEnd.value === 2 && !field.endDateTime));
}

export function isEmptyOrInvalidFieldRecurring(index, values) {
    const previousField = values.recurringUsageRatePlan[index];
    return !previousField || !previousField.eventType || !previousField.unitOfMeasurement || !previousField.priority || isEmptyOrInvalidBalanceImpactRecurringField(index, values, 0)
}

export const optionsForSelect = (value) => {
    let options = value.map(item => {
        return {
            label: item,
            value: item
        }
    })
    return options
}

export const handleStartDateChange = (selectedDate, setStartDate) => {
    let startDateList = ''
    startDateList = selectedDate[0]
    setStartDate(startDateList)
}

export const uomOptionsForUsage = (uomData, uomArray) => {
    let uomOptions = uomData
    uomOptions.forEach((value, index) => {
        uomArray.push(value.name)
    })
    return uomArray
}

export const resourceArrayData = (resourceData, resourceNameArray) => {
    resourceData.forEach((value, index) => {
        resourceNameArray.push(value.name)
    })
    return resourceNameArray
}
export const grantArrayData = (resourceData, grantResourceTypeArray) => {
    resourceData.forEach((value, index) => {

        grantResourceTypeArray.push(value.name)

    })
    return grantResourceTypeArray
}
export const chargeArrayData = (resourceData, chargeResourceTypeArray) => {
    resourceData.forEach((value, index) => {
        if (value.isCurrency === true) {
            chargeResourceTypeArray.push(value.name)
        }
    })
    return chargeResourceTypeArray
}

export const serviceDataOptions = (serviceData) => {
    let serviceOptions = serviceData.map(item => {
        return {
            label: item?.name,
            value: item?.serviceCode
        }
    })
    return serviceOptions
}
export const policyDataOptions = (Policies) => {
    let policiesOptions = Policies.map(item => {
        return {
            label: item?.policyLabel,
            value: item?.policyLabel
        }
    })
    return policiesOptions
}
export const aggregateResourceDataOptions = (aggregateResource) => {
    let aggregateResourceOptions = aggregateResource.map(item => {
        return {
            label: item?.name,
            value: item?.name
        }
    })
    return aggregateResourceOptions
}
export const termValidity = (unit, quantity) => {
    switch (+unit) {
        case 0:
            return <p> </p>
        case 1:
            return <p>{quantity} seconds</p>
        case 2:
            return <p>{quantity} days</p>
        case 3:
            return <p>{quantity} months</p>
        case 4:
            return <p>{quantity} quarters</p>
        case 5:
            return <p>{quantity} half years</p>
        case 6:
            return <p>{quantity} years</p>
        default:
            return <></>
    }
}

export const removeRowsFromGrantsAndCharges = (setInfinite, index, setCeiling, setFloor) => {
    setInfinite((prevInfinite) => {
        const newInfinite = [...prevInfinite];
        newInfinite.splice(index, 1);
        return newInfinite;
    });

    setCeiling((prevCeiling) => {
        const newCeiling = [...prevCeiling];
        newCeiling.splice(index, 1);
        return newCeiling;
    });

    setFloor((prevFloor) => {
        const newFloor = [...prevFloor];
        newFloor.splice(index, 1);
        return newFloor;
    });
}

export const handleServiceForOffer = (values, setFieldValue) => (val) => {
    values.serviceName = val
    setFieldValue(`serviceName`, val);
}
export const handlePolicyForOffer = (values, setFieldValue) => (val) => {
    values.policyName = val
    setFieldValue(`policyName `, val);
}
export const handleAggregateForOffer = (values, setFieldValue) => (val) => {
    values.aggregateVolume = val
    setFieldValue(`aggregateVolume `, val);
}

export const handleServiceChange = handleServiceForOffer(handleSelectedService);

export const formatBaseAndAddOnOfferColumns = (offers) => {
    const globalScope = [];
    const grant = [];
    const charge = [];
    const usage = [];
    columnDataFormat(offers, globalScope, grant, charge, usage);
    return { globalScope, grant, charge, usage };
};

export const extractBaseAndAddOnOfferDates = (offers) => {
    const endDatesArray = endDates(offers, []);
    const startDatesArray = startDates(offers, []);
    return { endDatesArray, startDatesArray };
};

export const checkEmptyPricingFieldsOnSubmit = (values) => {
    const recurringUsageList = values?.recurringUsageRatePlan || []
    return recurringUsageList?.some((usage) =>
        usage?.balanceImpacts?.some((impact) =>
          impact?.pricingModel?.value === "volume" ?  impact?.pricingModelNew?.some((item) =>
                !item?.startingUnit?.toString().trim() ||
                !item?.endingUnit?.toString().trim() ||
                !item?.pricePerUnit?.toString().trim()
            ) : false
        )
    );
}

export const checkServiceBarring = (values, serviceBarringState) => {
    if(values?.recurringCharges?.some((item) => item?.type == 1) && serviceBarringState) {
        toast.error("Service Barring is applicable only for recurring charges.");
        return true;
    }
    return false;
}

export const checkChargeRuleOnSubmit = (values) => {
    const recurringUsageList = values?.recurringUsageRatePlan || []
    if(recurringUsageList?.some((usage) =>
        usage?.balanceImpacts?.some((item) =>
          item?.chargeRule?.value?.trim() && (!item?.chargeImpact || item?.chargeImpact?.length === 0)
            ))
        ){
   return true;
    }
    return false;
}